import React, { useState, useEffect } from "react";
import CommonPaymentTap from "../views/payment/common-payment-tap";
import StorefrontTitle from "../views/shared/storefront-title.component";
import Translations from '../services/translation.service';
import CommonPaymentLogo from "../views/payment/common-payment-logo";
import FirebaseAnalytics from "../services/analytics.service";
import Storage from "../services/storage.service";

const subscriptions = [];
export default function BillPaymentTap(props) {
    const { history } = props;
    const [paymentProps, setPaymentProps] = useState(null);
    const [translationKeys, setTranslationsKeys] = useState(
        Translations.keys ? Translations.keys : {}
    );

	useEffect(() => {
		window.scrollTo({ top: 0, behavior: "smooth" });
        if (history?.location?.state && history?.location?.state?.paymentProps) {
            const paymentProps = history?.location?.state?.paymentProps;
            setPaymentProps(paymentProps);
            if(paymentProps?.tapPayload?.extraInformation?.totalAmount > 0){
                let firePayInfo = {
                    amt: paymentProps?.tapPayload?.extraInformation?.totalAmount || 0,
                    type: paymentProps?.tapPayload?.extraInformation?.payingFor || ""
                }
                Storage.set("firePayInfo", JSON.stringify(firePayInfo), true)
            }
            const firebase_event_params = {
                event_category: 'bills',
                event_screen: 'bills_details',
                interaction_type: 'click',
                event_label: 'pay_online',
                bill_number: '',
                bill_amount: '',
                payment_amount: paymentProps?.tapPayload?.extraInformation?.totalAmount || ''
            }
            FirebaseAnalytics.commonFunction(firebase_event_params);    
        }
	}, []) // eslint-disable-line react-hooks/exhaustive-deps

    useEffect(() => {
        window.scrollTo({ top: 0, behavior: "smooth" });
        subscriptions.push(
        Translations.getKeysObsrv().subscribe((data) => {
            setTranslationsKeys(data);
        })
        );

        return () => {
        if (subscriptions && subscriptions?.length) {
            for (let subscription of subscriptions) {
            subscription.unsubscribe();
            }
        }
        };
    }, []);

	return (
        <>
            <div className="bill-payment-accounts-conatiner">
                <StorefrontTitle
                    title={translationKeys["stm_enter_card_details_title"] || "Enter your card details"}
                    desc={translationKeys["stm_enter_card_details_desc"] || "Enter Payment Details"}
                />
            </div>
            <div className={`bill-payment-accounts-pay-conatiner bill-payment-accounts-pay-conatiner-show`}>
                <div className="common-payment-container">
                    <CommonPaymentTap tapPayload={paymentProps?.tapPayload} hideAppDownloads={true}/>
                    <CommonPaymentLogo />
                </div>
            </div>
        </>
	)
}